<template>
<div v-if="!gridStructure" class="flex lg:items-center flex-col md:flex-row md:px-4 px-0 lg:px-0 justify-between max-w-[1440px]">
  <div>
      <slot name="label" />
  </div>

  <div class="hidden mt-5 lg:flex md:mt-4">
      <button @click="moveLeft" :disabled="isOnStart" :class="{'opacity-50 ring-brand-gray-500 cursor-not-allowed [border:_1px_solid_rgba(251,101,255,0.24)]': isOnStart, 'text-brand-gray-900 hover:shadow-lg hover:[box-shadow:_0px_0px_12px_0px_rgba(251,101,255,0.24)_inset,_0px_0px_24px_0px_rgba(251,101,255,0.24)]': !isOnStart}" class="border border-brand-purple p-4 pt-[1.3rem] pb-[1.3rem] mr-6 transition-all duration-200 ease-out bg-brand-gray-900 shadow-md outline-none focus:outline-none focus:opacity-70 ring-brand-blue ring-opacity-25 text-brand-purple">
        <svg xmlns="http://www.w3.org/2000/svg" width="31" height="16" viewBox="0 0 31 16" fill="none">
          <path d="M0.292891 8.70711C-0.0976334 8.31658 -0.0976334 7.68342 0.292891 7.29289L6.65685 0.928932C7.04738 0.538408 7.68054 0.538408 8.07107 0.928932C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41421 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292891 8.70711ZM31 9H0.999998V7H31V9Z" fill="#FB65FF"/>
        </svg>

      </button>
      <button @click="moveRight" :disabled="isOnEnd" :class="{'opacity-50 ring-brand-gray-500 cursor-not-allowed [border:_1px_solid_rgba(251,101,255,0.24)]': isOnEnd, 'text-brand-gray-900 hover:shadow-lg hover:[box-shadow:_0px_0px_12px_0px_rgba(251,101,255,0.24)_inset,_0px_0px_24px_0px_rgba(251,101,255,0.24)]': !isOnEnd}" class="border border-brand-purple p-4 pt-[1.3rem] pb-[1.3rem] transition-all duration-200 ease-out bg-brand-gray-900 shadow-md outline-none focus:outline-none focus:opacity-70 ring-brand-blue ring-opacity-25 text-brand-purple">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="16" viewBox="0 0 32 16" fill="none">
          <path d="M31.2071 8.70711C31.5976 8.31658 31.5976 7.68342 31.2071 7.29289L24.8431 0.928932C24.4526 0.538408 23.8195 0.538408 23.4289 0.928932C23.0384 1.31946 23.0384 1.95262 23.4289 2.34315L29.0858 8L23.4289 13.6569C23.0384 14.0474 23.0384 14.6805 23.4289 15.0711C23.8195 15.4616 24.4526 15.4616 24.8431 15.0711L31.2071 8.70711ZM0.5 9H30.5V7H0.5V9Z" fill="#FB65FF"/>
        </svg>
      </button>
  </div>
</div>

<div class="grid-cols-9 gap-12 md:grid" v-else>
    <div class="flex col-span-3 md:justify-end"></div>
    <div class="col-span-6 flex justify-between">
        <slot name="label" />

        <div class="hidden mt-5 lg:flex md:mt-4">
            <button @click="moveLeft" :disabled="isOnStart" :class="{'opacity-50 ring-brand-gray-500 cursor-not-allowed': isOnStart, 'text-brand-gray-900 hover:shadow-lg': !isOnStart}" class="p-4 mr-2 transition-all duration-200 ease-out bg-white rounded-md shadow-md outline-none focus:outline-none focus:ring-4 ring-brand-blue ring-opacity-25 text-brand-gray-900">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.3068 5.6552C14.0471 5.66277 13.8005 5.77111 13.6193 5.95728L4.28594 15.2906C4.09847 15.4782 3.99316 15.7325 3.99316 15.9976C3.99316 16.2628 4.09847 16.5171 4.28594 16.7047L13.6193 26.038C13.7114 26.134 13.8218 26.2106 13.9439 26.2634C14.066 26.3162 14.1975 26.344 14.3305 26.3454C14.4636 26.3468 14.5955 26.3215 14.7187 26.2713C14.8419 26.221 14.9538 26.1466 15.0479 26.0525C15.1419 25.9585 15.2163 25.8465 15.2666 25.7234C15.3169 25.6002 15.3421 25.4682 15.3407 25.3352C15.3394 25.2021 15.3115 25.0707 15.2587 24.9486C15.2059 24.8265 15.1293 24.7161 15.0333 24.6239L7.40703 16.9976H26.993C27.1255 16.9995 27.257 16.975 27.38 16.9256C27.503 16.8762 27.6149 16.8028 27.7093 16.7098C27.8036 16.6168 27.8786 16.5059 27.9297 16.3836C27.9809 16.2614 28.0072 16.1302 28.0072 15.9976C28.0072 15.8651 27.9809 15.7339 27.9297 15.6117C27.8786 15.4894 27.8036 15.3785 27.7093 15.2855C27.6149 15.1924 27.503 15.1191 27.38 15.0697C27.257 15.0203 27.1255 14.9958 26.993 14.9976H7.40703L15.0333 7.37135C15.1776 7.23084 15.2761 7.05006 15.3159 6.85265C15.3557 6.65525 15.335 6.45042 15.2565 6.26498C15.178 6.07953 15.0453 5.92211 14.8759 5.81331C14.7064 5.70451 14.5081 5.6494 14.3068 5.6552Z" fill="currentColor"/>
                    </svg>

            </button>
            <button @click="moveRight" :disabled="isOnEnd" :class="{'opacity-50 ring-brand-gray-500 cursor-not-allowed': isOnEnd, 'text-brand-gray-900 hover:shadow-lg': !isOnEnd}" class="p-4 transition-all duration-200 ease-out bg-white rounded-md shadow-md outline-none focus:outline-none focus:ring-4 ring-brand-blue ring-opacity-25 text-brand-gray-900">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.6637 5.6543C17.4646 5.65435 17.2702 5.71377 17.1051 5.82496C16.9401 5.93616 16.8119 6.09407 16.7371 6.27849C16.6623 6.46291 16.6443 6.66546 16.6852 6.86021C16.7262 7.05497 16.8243 7.23307 16.967 7.37174L24.5933 14.998H5.00741C4.87489 14.9962 4.74333 15.0207 4.62036 15.0701C4.4974 15.1195 4.38547 15.1928 4.2911 15.2859C4.19673 15.3789 4.1218 15.4898 4.07065 15.6121C4.0195 15.7343 3.99316 15.8655 3.99316 15.998C3.99316 16.1306 4.0195 16.2618 4.07065 16.384C4.1218 16.5063 4.19673 16.6172 4.2911 16.7102C4.38547 16.8033 4.4974 16.8766 4.62036 16.926C4.74333 16.9754 4.87489 16.9999 5.00741 16.998H24.5933L16.967 24.6244C16.8711 24.7165 16.7945 24.8269 16.7417 24.949C16.6889 25.0711 16.661 25.2026 16.6596 25.3356C16.6583 25.4686 16.6835 25.6006 16.7338 25.7238C16.7841 25.847 16.8584 25.9589 16.9525 26.0529C17.0466 26.147 17.1585 26.2214 17.2817 26.2717C17.4049 26.322 17.5368 26.3472 17.6699 26.3458C17.8029 26.3445 17.9343 26.3166 18.0565 26.2638C18.1786 26.211 18.289 26.1344 18.3811 26.0384L27.7144 16.7051C27.9019 16.5175 28.0072 16.2632 28.0072 15.998C28.0072 15.7329 27.9019 15.4786 27.7144 15.291L18.3811 5.95768C18.2879 5.86169 18.1764 5.78538 18.0531 5.73327C17.9299 5.68116 17.7975 5.6543 17.6637 5.6543Z" fill="currentColor"/>
                </svg>
            </button>
        </div>
    </div>
</div>

<div v-if="width > 1000" ref="carousel" :style="{ width: scrollContainerWidth}" class="relative pl-4 z-10 inline-flex mt-6 space-x-6 overflow-x-hidden overflow-y-hidden">
    <slot/>
</div>

<div v-else ref="carousel" class="flex justify-center">
    <div :style="{ width: scrollContainerWidth}" class="relative z-10 inline-flex mt-6 space-x-6 overflow-x-scroll overflow-y-hidden">
        <slot/>
    </div>
</div>

</template>

<script>

import { ref, computed } from 'vue';
import { useWindowSize } from '@vueuse/core'

export default {

    props: {
        cardWidth: {
            type: Number
        },
        visibleCards: {
            type: Number
        },
        gridStructure: {
            type: Boolean,
            default: false
        }
    },

    setup({cardWidth, visibleCards}) {

        const { width } = useWindowSize();

        const carousel = ref("");
        const scrollAmount = ref(0);

        const isOnEnd = computed(() => {
            if(carousel.value) {
                return scrollAmount.value >= carousel.value.scrollWidth - ((visibleCards * cardWidth) - 50);
            }
        });

        const isOnStart = computed(() => {
            return scrollAmount.value <= 0;
        })

        const moveLeft = () => {
            if((scrollAmount.value - cardWidth) > 0) {
                scrollAmount.value -= cardWidth*2;
            } else {
                scrollAmount.value = 0;
            }
            carousel.value.scrollTo({
                top: 0,
                left: scrollAmount.value,
                behavior: 'smooth'
            })
        }

        const moveRight = () => {
            if((scrollAmount.value + cardWidth) < carousel.value.scrollWidth) {
                scrollAmount.value += cardWidth*2;
            } else {
                scrollAmount.value = carousel.value.scrollWidth;
            }
            carousel.value.scrollTo({
                top: 0,
                left: scrollAmount.value,
                behavior: 'smooth'
            })
        }

        const scrollContainerWidth = computed(() => {
            if(width.value > 1614) {
                return (1600 - 250) + 'px'
            }

            if(width.value > 1000) {
                const sides = width.value - 960;
                const cont =  width.value - ( sides / 2 ) - 20;

                return cont + 'px';
            }

            // if(width.value > cardWidth * 2) {
            //    return (cardWidth * 2) + "px";
            // }

            if(width.value > cardWidth) {
               return (width.value -50) + "px";
            }

        })

        return {
            carousel,
            moveLeft,
            moveRight,
            isOnEnd,
            isOnStart,
            scrollContainerWidth,
            width
        }
    }
}
</script>

<style>

</style>
